<template>
  <v-card
    :class="`${releaseBriefSurfaceClass} elevation-0`"
    min-width="300px"
    max-width="450px"
    width="100%"
  >
    <v-col>
      <v-row
        :class="`${releaseBriefHeaderSurfaceClass} white--text font-weight-medium align-center pa-3`"
      >
        <v-col>
          <span class="px-1 header-2 font-weight-bold cursor-pointer">
            Release Brief
          </span>
        </v-col>

        <v-spacer />

        <!-- <v-col
          class="cursor-pointer text-right"
        >
          <v-icon
            class="white--text"
            @click="goToDocs"
          >
            open_in_new
          </v-icon>
        </v-col> -->
      </v-row>

      <v-row
        class="pa-6"
      >
        <v-col>
          <!-- <v-row class="body-2 mb-6">
            <span>
              iAdOps is committed to providing a secure and reliable platform for our users. Below are
              some of the latest security updates implemented to enhance the security of your account and data.
            </span>
          </v-row> -->

          <v-row
            v-if="isInternalUser"
            class="pt-3"
          >
            <v-col>
              <v-row class="font-weight-bold body-2">
                Engagement Model Admin and Routing Foundation
              </v-row>

              <v-row class="caption font-weight-medium pt-1">
                <p>
                  Engagement Model Phase 2 admin tooling is now in place with
                  CRUD management for engagement types, contract types, and
                  assignment rules. Backend admin dispatch wiring in iadops-core
                  was also completed, including assignment-rule priority update
                  support used by the new reordering controls.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-if="isInternalUser"
            class="pt-3"
          >
            <v-col>
              <v-row class="font-weight-bold body-2">
                Projects Real-Time Sync and Admin Code Rename
              </v-row>

              <v-row class="caption font-weight-medium pt-1">
                <p>
                  Projects dashboard cards and rows now update in near real-time
                  when project records change in Firestore. Internal admin users
                  can also rename a project code directly from the dashboard with
                  built-in validation, review confirmation, and safe supersede
                  tracking.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-if="isInternalUser"
            class="pt-3"
          >
            <v-col>
              <v-row class="font-weight-bold body-2">
                Tour System Professional Polish
              </v-row>

              <v-row class="caption font-weight-medium pt-1">
                <p>
                  Guided tour cards and highlights were refreshed to better
                  match iAdOps brand styling, tour actions in the Help menu are
                  easier to scan, and fallback tour messaging now points users
                  directly to Page Guide when a route has no available tour.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-if="isInternalUser"
            class="pt-3"
          >
            <v-col>
              <v-row class="font-weight-bold body-2">
                Project Dashboard Improvements
              </v-row>

              <v-row class="caption font-weight-medium pt-1">
                <p>
                  Project filtering is now more accurate&mdash;archived and deleted
                  projects only appear in their dedicated tabs, and tab counts
                  no longer shift after page load. Filters support multi-select,
                  card hover behavior is now visually stable, and the initial
                  card loading cycle no longer flickers while time entries
                  resolve. Card header spacing and text hierarchy were tightened
                  for better readability and alignment with card body/footer
                  content. Follow-up loading-state hardening ensures cards do
                  not stay stuck in "Loading time entries..." when API responses
                  fail or return invalid payloads. Description column visibility now works properly, and
                  profile pages include a back button with 3-level breadcrumbs.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            class="pt-3"
          >
            <v-col>
              <v-row class="font-weight-bold body-2">
                Theme-Aware Sign-In Page &amp; Dark Mode Accessibility
              </v-row>

              <v-row class="caption font-weight-medium pt-1">
                <p>
                  The sign-in page now automatically adapts to your operating
                  system's theme preference, with theme-aware gradients and
                  properly contrasted buttons for both light and dark modes.
                  Dark mode now loads instantly without a white flash, shared
                  UI surfaces follow a more consistent theme path, and invalid
                  settings payloads are blocked before they can corrupt saved
                  preferences.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-if="isInternalUser"
            class="pt-3"
          >
            <v-col>
              <v-row class="font-weight-bold body-2">
                Admin Project Enhancements
              </v-row>

              <v-row class="caption font-weight-medium pt-1">
                <p>
                  Editing a project's status or type in the admin interface now updates the table row immediately.
                  Projects-tab issue summary counts stay aligned with visible rows when filters or search are active.
                  The Sheets diff control now shows the active mode in a dropdown-style button, and diff mode applies
                  suggested columns without restricting the column picker. View Details now clearly labels Firestore,
                  API, and Sheet record sections for faster cross-system review.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-if="isInternalUser"
            class="pt-3"
          >
            <v-col>
              <v-row class="font-weight-bold body-2">
                Admin Feedback Dashboard
              </v-row>

              <v-row class="caption font-weight-medium pt-1">
                <p>
                  Internal admins can now manage in-app feedback from a single
                  dashboard with status updates, internal notes, CSV export,
                  and immediate email-recipient settings for new submissions.
                  Email notification delivery degrades gracefully when auth is
                  not configured, so feedback capture continues even when
                  notification setup is incomplete.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-if="isInternalUser"
            class="pt-3"
          >
            <v-col>
              <v-row class="font-weight-bold body-2">
                Guided Tours &amp; Onboarding Improvements
              </v-row>

              <v-row class="caption font-weight-medium pt-1">
                <p>
                  New interactive tours guide first-time users through Admin Projects, Time entry, and Projects workflows with interactive element highlights and step-by-step walkthroughs. The onboarding card is now professionally redesigned with compact buttons and cleaner tooltips. Tours are automatically saved to browser storage for resume across sessions.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row class="pt-3">
            <v-col>
              <v-row class="font-weight-bold body-2">
                Help and Docs Navigation Refresh
              </v-row>

              <v-row class="caption font-weight-medium pt-1">
                <p>
                  Help actions are now grouped more clearly by task, Docs and
                  What&apos;s New links are easier to reach from navigation, and
                  the sidebar scroll behavior was fixed so the Docs page remains
                  reachable on shorter screens.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-if="isInternalUser"
            class="pt-3"
          >
            <v-col>
              <v-row class="font-weight-bold body-2">
                Delivery View Crash Fix
              </v-row>

              <v-row class="caption font-weight-medium pt-1">
                <p>
                  Fixed a render crash on Discrepancy and Pacing views where
                  rows without normalized delivery data caused a TypeError in
                  the Custom Fields column. Affected rows now display correctly.
                </p>
              </v-row>
            </v-col>
          </v-row>

          <v-row
            v-if="isInternalUser"
            class="pt-4"
          >
            <v-col>
              <v-divider class="mb-4" />

              <v-row class="font-weight-bold body-2">
                Stakeholder Communication
              </v-row>

              <v-row class="caption font-weight-medium pt-1 mb-3">
                <p>
                  Internal users can copy launch-ready release communication directly from the dashboard or the Docs
                  release notes page, now with a dedicated Release Kit sidebar item for faster access.
                </p>
              </v-row>

              <v-row class="mb-2">
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-btn
                    outlined
                    block
                    class="text-none"
                    @click="copyReleaseCommunication('email')"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'copy']"
                      class="mr-2"
                    />
                    Copy Email
                  </v-btn>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-btn
                    outlined
                    block
                    class="text-none"
                    @click="copyReleaseCommunication('slack')"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'copy']"
                      class="mr-2"
                    />
                    Copy Slack
                  </v-btn>
                </v-col>

                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                >
                  <v-btn
                    outlined
                    block
                    class="text-none"
                    @click="copyReleaseCommunication('forward')"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'copy']"
                      class="mr-2"
                    />
                    Copy Forward Note
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>

    <v-snackbar
      v-model="showCopySnackbar"
      :timeout="2000"
      color="success"
    >
      {{ copySnackbarMessage }}
    </v-snackbar>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import themeClasses from '@/mixins/themeClasses'

const { mapGetters: mapAuthGetters, mapState } = createNamespacedHelpers('auth')

export default {
  name: 'WelcomeCard',
  mixins: [themeClasses],
  data() {
    return {
      dismissed: null,
      showCopySnackbar: false,
      copySnackbarMessage: '',
    }
  },
  computed: {
    ...mapAuthGetters([
      'alert',
      'isInternalUser',
    ]),
    ...mapState({
      user: (state) => state.user,
    }),
    releaseBriefSurfaceClass() {
      return this.themeSurfaceColor('white', '')
    },
    releaseBriefHeaderSurfaceClass() {
      return this.themeSurfaceColor('primary', 'darkblue')
    },

    stakeholderEmailText() {
      return [
        'Subject: iAdOps Q1 2026 release summary',
        '',
        'Team,',
        '',
        'We have completed the latest iAdOps Q1 2026 release cycle.',
        'This release centers on stronger Projects and Admin workflows,',
        'better onboarding support, improved authentication reliability,',
        'and safer project-data operations.',
        '',
        'Highlights:',
        '- Admin Project create flows are now more consistent across',
        '  Projects and Sheets workflows.',
        '- Firestore project operations use safer merge-write behavior',
        '  in key merge and repair paths.',
        '- The project-data audit packet and review outputs were refreshed',
        '  to support remediation planning.',
        '- Dashboard onboarding, guided tours, contextual help, and QA',
        '  checklist coverage continue to mature as product features.',
        '- Fixed a render crash on Discrepancy and Pacing views in the',
        '  Custom Fields column when delivery data lacks normalization.',
        '',
        'Release tags:',
        '- v5.7.0-prod.20260402.5f60000',
        '- v5.7.1-prod.20260402.e432cd6',
        '- v5.12.0-prod.20260406.e74dcba',
        '',
        'We also updated release documentation and internal QA summaries',
        'to make this release window easier to communicate and review.',
        '',
        'Thanks,',
        'Technology',
      ].join('\n')
    },

    stakeholderSlackText() {
      return [
        'iAdOps Q1 2026 release update',
        '',
        'The latest release cycle is complete.',
        '',
        'What changed:',
        '- Admin Project create flows now behave more consistently across Projects and Sheets.',
        '- Firestore project merge and repair paths now use safer merge-write behavior.',
        '- Project-data audit outputs and handoff docs were refreshed for remediation follow-up.',
        '- Onboarding, help, tours, and QA coverage continue to expand across the app.',
        '- Fixed a crash in Discrepancy and Pacing Custom Fields column.',
        '',
        'Latest tags:',
        '- v5.7.0-prod.20260402.5f60000',
        '- v5.7.1-prod.20260402.e432cd6',
        '- v5.12.0-prod.20260406.e74dcba',
        '',
        'Release notes and internal QA summary are updated in Docs.',
      ].join('\n')
    },

    stakeholderForwardText() {
      return [
        'Subject: iAdOps release update for client sharing',
        '',
        'Hi team,',
        '',
        'Here is a concise summary you can forward when clients or',
        'cross-functional partners ask what changed in the latest',
        'iAdOps release cycle.',
        '',
        'Highlights:',
        '- Project and admin workflows are more consistent and easier to manage.',
        '- Data handling around project maintenance is safer and more reliable.',
        '- Onboarding, help content, and release documentation are easier to use.',
        '',
        'If you need the internal launch summary or full release details,',
        'see the release notes in iAdOps Docs.',
        '',
        'Thanks,',
        'Technology',
      ].join('\n')
    },
  },
  methods: {
    async copyReleaseCommunication(type) {
      let text = this.stakeholderForwardText
      let message = 'Forward note copied to clipboard.'

      if (type === 'email') {
        text = this.stakeholderEmailText
        message = 'Stakeholder email copied to clipboard.'
      } else if (type === 'slack') {
        text = this.stakeholderSlackText
        message = 'Slack summary copied to clipboard.'
      }

      try {
        await navigator.clipboard.writeText(text)
        this.copySnackbarMessage = message
        this.showCopySnackbar = true
      } catch (error) {
        this.copySnackbarMessage = 'Could not copy release communication.'
        this.showCopySnackbar = true
      }
    },

    goToDocs() {
      this.$router.push('/docs/release-notes')
      this.dismissFeaturePrompt()
    },
    async dismissFeaturePrompt() {
      this.dismissed = true

      const { user } = this
      const { email, personEmail, settings = {} } = user
      const alert = { dismissed: true }
      const doc = { settings: { ...settings, alert } }
      const docId = email || personEmail
      const data = { doc, docId }

      return this.$store.dispatch('auth/updateUserSettings', data)
    },
  },
}
</script>
